import * as CommonConstants from 'Common/constants/commonConstants';
import * as SiteViewConstants from './SiteViewConstants';
import { produce } from "immer";

// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require("object.assign");

const initialState = {
    fetchSiteViewFiltersErrMsg: "",
    fetchSiteViewFiltersStatus: "",
    siteViewFiltersData: {
        customerName: [],
        state: [],
        city: []
    },

    fetchCustomerSitesStatus: "",
    fetchCustomerSitesErrMsg: "",
    customerSitesData: [],
    hasMoreCustomerSites: false,

    fetchSiteInstrumentsDataStatus: "",
    fetchSiteInstrumentsErrMsg: "",
    siteInstrumentsData: {},

    selectedFilters: {
        customer: [],
        state: [],
        city: []
    }
};

export default function SiteViewReducer(state = initialState, action) {
    switch (action.type) {
        case SiteViewConstants.FETCH_SITE_VIEW_FILTERS_REQUEST: {
            console.log("fetchSiteViewFilters:FETCH_SITE_VIEW_FILTERS_REQUEST: action: ", action);
            const newState = {
                ...state,
                fetchSiteViewFiltersStatus: CommonConstants.STATUS_PENDING
            };
            return assign({}, state, newState);
        }
        case SiteViewConstants.FETCH_SITE_VIEW_FILTERS_SUCCESS: {
            console.log("fetchSiteViewFilters:FETCH_SITE_VIEW_FILTERS_SUCCESS: action: ", action);
            const newState = {
                ...state,
                fetchSiteViewFiltersStatus: CommonConstants.STATUS_SUCCESS,
                siteViewFiltersData : {
                    customerName : action.result.customerName,
                    state : action.result.state,
                    city : action.result.city
                }
            };
            return assign({}, state, newState);
        }
        case SiteViewConstants.FETCH_SITE_VIEW_FILTERS_FAILURE: {
            console.log("fetchSiteViewFilters:FETCH_SITE_VIEW_FILTERS_FAILURE: action: ", action);
            const newState = {
                ...state,
                fetchSiteViewFiltersStatus: CommonConstants.STATUS_FAILED, 
                fetchSiteViewFiltersErrMsg: CommonConstants.GENERIC_ERROR_MESSAGE
            };
            return assign({}, state, newState);
        }
        case SiteViewConstants.FETCH_CUSTOMER_SITES_REQUEST: {
            const newState = {
                ...state,
                fetchCustomerSitesStatus: CommonConstants.STATUS_PENDING, 
                fetchCustomerSitesErrMsg: ""
            };
            return assign({}, state, newState);
        }
        case SiteViewConstants.FETCH_CUSTOMER_SITES_SUCCESS: {
            const newState = {
                ...state,
                fetchCustomerSitesStatus: CommonConstants.STATUS_SUCCESS, 
                fetchCustomerSitesErrMsg: "",
                customerSitesData: action.offset == 0 ? [...action.result] : [...state.customerSitesData, ...action.result],
                hasMoreCustomerSites: action.result.length == 5 ? true : false
            };
            return assign({}, state, newState);
        }
        case SiteViewConstants.FETCH_CUSTOMER_SITES_FAILURE: {
            const newState = {
                ...state,
                fetchCustomerSitesStatus: CommonConstants.STATUS_FAILED, 
                fetchCustomerSitesErrMsg: CommonConstants.GENERIC_ERROR_MESSAGE,
                customerSitesData: [],
                hasMoreCustomerSites: false
            };
            return assign({}, state, newState);
        }
        case SiteViewConstants.FETCH_SITE_INSTRUMENTS_DATA_REQUEST: {
            const newState = {
                ...state,
                fetchSiteInstrumentsDataStatus: CommonConstants.STATUS_PENDING, 
                fetchSiteInstrumentsErrMsg: "",
                siteInstrumentsData: {},
            };
            return assign({}, state, newState);
        }
        case SiteViewConstants.FETCH_SITE_INSTRUMENTS_DATA_SUCCESS: {
            const newState = {
                ...state,
                fetchSiteInstrumentsDataStatus: CommonConstants.STATUS_SUCCESS,
                fetchSiteInstrumentsErrMsg: "",
                siteInstrumentsData: {...action.result}
            };
            return assign({}, state, newState);
        }
        case SiteViewConstants.FETCH_SITE_INSTRUMENTS_DATA_FAILURE: {
            const newState = {
                ...state,
                fetchSiteInstrumentsDataStatus: CommonConstants.STATUS_FAILED,
                fetchSiteInstrumentsErrMsg: CommonConstants.GENERIC_ERROR_MESSAGE,
                siteInstrumentsData: {}
            };
            return assign({}, state, newState);
        }
        case SiteViewConstants.RESET_SITE_INSTRUMENTS_DATA: {
            const newState = {
                ...state,
                fetchSiteInstrumentsDataStatus: "",
                fetchSiteInstrumentsErrMsg: "",
                siteInstrumentsData: {}
            };
            return assign({}, state, newState);
        }
        case SiteViewConstants.RESET_CUSTOMER_SITES_DATA: {
            const newState = {
                ...state,
                fetchCustomerSitesStatus: "",
                fetchCustomerSitesErrMsg: "",
                customerSitesData: []
            };
            return assign({}, state, newState);
        }

        default:
            return state;
    }
}
